import React from "react";

import ScoutCompany from "modules/tractionAI/screens/scout/scoutCompany";

const ScoutCompanies = ({ companies, index }) => {
  return (
    <div className="d-flex flex-column ">
      {
        companies.map((company, idx) => (
          <ScoutCompany
            parentIndex={index}
            index={idx}
            key={idx}
            company={company}
          />
        ))
      }
    </div>
  );
};

export default React.memo(ScoutCompanies);
